<template>
  <div class="p-grid p-jc-start">
    <div
      v-for="(bovineType, index) in items"
      :key="index"
      style="margin: 0 7px 5px 7px"
    >
      <BovineType
        style="width: fit-content; padding: 0px 10px; word-wrap: normal"
        :small="true"
        :type="bovineType.type"
        :customText="getText(bovineType)"
        :inactive="inactive"
      />
    </div>
  </div>
</template>

<script>
import BovineType from './BovineType';

export default {
  name: 'BovinesTypeSummary',
  components: {
    BovineType,
  },
  props: {
    bovines: Array,
    bovinesTypes: Array,
    inactive: Boolean,
  },
  computed: {
    items() {
      if (this.bovinesTypes) {
        return this.bovinesTypes;
      }
      const data = (this.bovines || []).reduce((final, bovine) => {
        if (!final[bovine.typeId]) {
          final[bovine.typeId] = {
            type: bovine.type,
            count: 1,
          };
        } else {
          final[bovine.typeId].count += 1;
        }
        return final;
      }, {});
      return Object.values(data);
    },
  },
  methods: {
    getText(data) {
      const name = data.count > 1 ? `${data.type.name}s` : data.type.name;
      return `${data.count} ${name}`;
    },
  },
};
</script>

<style>
</style>
